<script>
  import { portfolio, updateSettings } from '../../os/portfolio.svelte.js';

  let { openPopover, batteryLevel } = $props();

  let connectedNetwork = $state('FaizanLab-5G');
  const networks = [
    { name: 'FaizanLab-5G', bars: 3, locked: true },
    { name: 'AquaOS Hotspot', bars: 3, locked: true },
    { name: 'Definitely Not A Honeypot', bars: 2, locked: false },
    { name: "Neighbor's WiFi (do not)", bars: 1, locked: true },
  ];
  const btDevices = [
    { name: 'Retro Keyboard', connected: true },
    { name: 'Hockey Puck Mouse', connected: true },
    { name: 'iPod (simulated)', connected: false },
  ];
</script>

{#if openPopover === 'volume'}
  <div
    class="popover"
    style="right: 96px"
    onclick={(e) => e.stopPropagation()}
    onpointerdown={(e) => e.stopPropagation()}
  >
    <h4>Sound</h4>
    <label for="alert-volume">Volume</label>
    <input
      id="alert-volume"
      type="range"
      min="0"
      max="1"
      step="0.05"
      value={portfolio.settings.alertVolume}
      oninput={(e) => updateSettings({ alertVolume: Number(e.currentTarget.value) })}
    />
    <label class="row"
      ><input
        type="checkbox"
        checked={portfolio.settings.uiSounds !== false}
        onchange={(e) => updateSettings({ uiSounds: e.currentTarget.checked })}
      /> Interface clicks</label
    >
  </div>
{/if}

{#if openPopover === 'battery'}
  <div
    class="popover"
    style="right: 130px"
    onclick={(e) => e.stopPropagation()}
    onpointerdown={(e) => e.stopPropagation()}
  >
    <h4>Battery <span class="bolt" class:charging={batteryLevel < 100}>⚡</span></h4>
    <div class="battery-bar"><div class="battery-fill" style={`width:${batteryLevel}%`}></div></div>
    <p class="fine">{batteryLevel}% — Power Source: Imagination</p>
    <p class="fine dim">Simulated cells never wear out.</p>
  </div>
{/if}

{#if openPopover === 'wifi'}
  <div
    class="popover"
    style="right: 160px"
    onclick={(e) => e.stopPropagation()}
    onpointerdown={(e) => e.stopPropagation()}
  >
    <h4>AirPort: On</h4>
    {#each networks as net (net.name)}
      <button class="net-row" onclick={() => (connectedNetwork = net.name)}>
        <span class="tick">{connectedNetwork === net.name ? '✓' : ''}</span>
        <span class="net-name">{net.name}</span>
        <span class="net-meta">{net.locked ? '🔒' : ''}{'▂▄▆'.slice(0, net.bars)}</span>
      </button>
    {/each}
    <p class="fine dim">All networks equally imaginary.</p>
  </div>
{/if}

{#if openPopover === 'bluetooth'}
  <div
    class="popover"
    style="right: 190px"
    onclick={(e) => e.stopPropagation()}
    onpointerdown={(e) => e.stopPropagation()}
  >
    <h4>Bluetooth: On</h4>
    {#each btDevices as dev (dev.name)}
      <div class="net-row static">
        <span class="tick">{dev.connected ? '●' : '○'}</span>
        <span class="net-name">{dev.name}</span>
        <span class="net-meta dim">{dev.connected ? 'Connected' : 'Not Connected'}</span>
      </div>
    {/each}
  </div>
{/if}

<style>
  .popover {
    position: fixed;
    top: 30px;
    display: flex;
    flex-direction: column;
    gap: 7px;
    min-width: 210px;
    padding: 10px 12px;
    background: rgba(40, 43, 43, 0.98);
    border: 2px solid;
    border-color: #5f6a69 #131717 #131717 #5f6a69;
    outline: 1px solid #000;
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.14),
      0 10px 28px rgba(0, 0, 0, 0.6);
    z-index: 10000030;
    font-size: 12px;
    color: #d7dcdc;
  }
  .popover h4 {
    margin: 0 0 2px;
    font-size: 12px;
    color: #fff;
    display: flex;
    justify-content: space-between;
  }
  .popover label {
    font-size: 11px;
    color: #bbb;
  }
  .popover label.row {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #d7dcdc;
  }
  .popover input[type='range'] {
    width: 100%;
    accent-color: #4d91c9;
  }
  .fine {
    margin: 0;
    font-size: 11px;
  }
  .dim {
    color: #8b9394;
  }

  .battery-bar {
    height: 12px;
    border: 2px solid #131717;
    outline: 1px solid rgba(255, 255, 255, 0.15);
    background: #171a1a;
    padding: 1px;
  }
  .battery-fill {
    height: 100%;
    background: repeating-linear-gradient(90deg, #45b05c 0 6px, #328445 6px 8px);
    transition: width 0.4s ease;
  }
  .bolt {
    opacity: 0.25;
  }
  .bolt.charging {
    opacity: 1;
    animation: bolt-blink 1.4s steps(1) infinite;
  }
  @keyframes bolt-blink {
    50% {
      opacity: 0.3;
    }
  }

  .net-row {
    display: grid;
    grid-template-columns: 14px 1fr auto;
    gap: 6px;
    align-items: center;
    width: 100%;
    padding: 4px 5px;
    background: transparent;
    border: 0;
    color: #d7dcdc;
    font: 12px var(--font);
    text-align: left;
    cursor: pointer;
  }
  .net-row:not(.static):hover {
    background: rgba(77, 145, 201, 0.4);
  }
  .net-row.static {
    cursor: default;
  }
  .tick {
    color: #8fd0ff;
  }
  .net-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .net-meta {
    font-size: 10px;
    letter-spacing: 1px;
  }
</style>
